<template>
  <FormWrapper grid>
    <div v-if="runningBatch" class="text-sm font-medium text-gray-700">
      There's a running spreadsheet import. To upload another one, you should wait for the previous one to finish.
    </div>
    <form @submit.prevent="submit" v-else>
      <div class="mt-1 sm:mt-0 sm:col-span-4">
        <div class="max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md"
             :class="{
                'border-red-300': errors.file,
                'border-gray-300': !errors.file,
             }">
          <div class="space-y-1 text-center">
            <div class="flex text-sm text-gray-600">
              <label for="file-upload" class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                <span v-if="form.file">Change file</span>
                <span v-else>Upload a file</span>
                <input id="file-upload"
                       type="file"
                       class="sr-only"
                       accept=".xlsx,.csv"
                       @input="updateFile($event)"
                       />
                <p class="text-xs text-red-500" v-if="errors.file">
                  {{ errors.file }}
                </p>
                <p class="text-xs text-gray-500" v-if="form.file">
                  {{ form.file.name }}
                </p>
              </label>
            </div>
          </div>
        </div>
      </div>

      <FormCheckbox v-model="form.algolia"
                    name="algolia"
                    label="Update search index"
                    class="col-span-4"
                    :errors="errors" />

      <FormCheckbox v-model="form.shopify"
                    name="shopify"
                    label="Update Shopify"
                    class="col-span-4"
                    :errors="errors" />

      <FormSelect v-model="form.type"
                  name="type"
                  label="Type"
                  :options="[
                    { value: 'ADD DATA', label: 'ADD DATA' },
                    { value: 'REVISE DATA', label: 'REVISE DATA' },
                    { value: 'DELETE DATA', label: 'DELETE DATA' },
                    { value: 'OTHER', label: 'OTHER' },
                  ]"
                  class="col-span-4"
                  :error="errors.type" />

      <FormTextarea v-model="form.note"
                    name="note"
                    label="Note"
                    class="col-span-4"
                    :error="errors.note" />

      <FormActions :cancelUrl="$route('builds.index')"
                   :submitLabel="form.processing ? 'Please wait' : undefined"
                   :disabled="form.processing"
                   grid />
    </form>
  </FormWrapper>
</template>

<script>
import { Inertia } from '@inertiajs/inertia'
import { useForm, Link } from '@inertiajs/inertia-vue3'
import FormComponent from '@/pages/form-component'
import LastBatch from '@/mixins/last-batch'

export default {
  mixins: [
    FormComponent,
    LastBatch,
  ],

  props: {
    lastBatch: Object,
    errors: Object,
  },

  setup() {
    const form = useForm({
      algolia: true,
      shopify: true,
      file: null,
      type: 'ADD DATA',
      note: '',
    })

    return { form }
  },

  methods: {
    updateFile($event) {
      this.form.file = $event.target.files[0]
    },
    submit() {
      this.form.post(this.$route('spreadsheets.upload'))
    },
  }
}
</script>
